import React, { useState, useEffect } from 'react';
import { TestCardCol } from '../ui-components';
import {View, withAuthenticator} from '@aws-amplify/ui-react';
import { generateClient } from 'aws-amplify/api';
import * as queries from '../graphql/queries';

const client = generateClient();

const TestsPage = ({ onStartQuiz, grade }) => {
    const [filteredItems, setFilteredItems] = useState([]);
    const startQuiz = (test) => {
        onStartQuiz(test);
    };

    useEffect(() => {
        const fetchTests = async () => {
            try {
                const result = await client.graphql({
                    query: queries.listTests,
                    variables: {
                        filter: {
                            Grade: {
                                eq: grade
                            }
                        }
                    }
                });
                const items = result.data.listTests.items;
                // const filtered = items.filter(item => item.Grade === grade);
                setFilteredItems(items);
            } catch (error) {
                console.error('Error fetching tests:', error);
            }
        };

        fetchTests();
    }, [grade]);

    return (
        <View
            padding={"large"}
            margin={"large"}
        >
            <TestCardCol
                gap={"25px"}
                items={filteredItems}
                // columnCount="3"
                margin={"large"}
                overrideItems={({ item, index }) => ({

                    // backgroundColor: index % 2 === 0 ? 'white' : 'lightgray',
                    onClick: () => startQuiz(item),
                    overrides: {
                        "margin": "25px",
                        Button: {
                            onClick: () => startQuiz(item)
                        }
                    }
                })}
            />
        </View>
    );
};

export default withAuthenticator(TestsPage, {
    includeGreetings: true,
    formFields: {
        signUp: {
            email: { isRequired: true },
            family_name: { isRequired: true },
            given_name: { isRequired: true },
        }
    }
});